import {Injectable, Type} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpEvent, HttpHeaders, HttpRequest} from '@angular/common/http';

import {Observable, of, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {environment} from "../../../environments/environment";
import {DtoDeviceInfo, DtoLoginRequest, DtoLoginResponse, DtoLoginResponseFailed} from "../interfaces/core.types";


@Injectable({ providedIn: 'root' })
export abstract class CoreApiService {

  public static baseUrl: string = environment.API_URL + "/";

  constructor(protected http: HttpClient) {}


  public getDeviceInfo() : DtoDeviceInfo {
    return {
      deviceType: "DEVICE_BROWSER",
      deviceId: "NDF",
      notificationToken: "NDF"
    };
  }

  protected getUrlViaEndPoint(endPoint: string) : string {
    return CoreApiService.baseUrl + endPoint;
  }


  public getList(endPoint: string) : Observable<any> {

    let urlViaEndPoint = this.getUrlViaEndPoint(endPoint);

    return this.http.get<any>(urlViaEndPoint).pipe(
        map(
            value => {
              return value;
            }
        ),
        catchError(this.handleError<any>('listGet', null))
    );

  }




  /**
   * Perform actual GET.
   * @param id
   * @param light
   * @protected
   */
  public get(endPoint: string, queryParams: any = {}): Observable<any> {

    let url = this.getUrlViaEndPoint(endPoint);

    return this.http.get<any>(url, { ...queryParams } ).pipe(
        tap(dtoDetail => {

        }),
        catchError(this.handleError<any>(`get URL=${url}`))
    );

  }

  protected getInternalReturnList(endPoint: string, queryParams: any = {}) : Observable<any>  {

    return this.http.get<any>(CoreApiService.baseUrl + endPoint, { params: queryParams} ).pipe(
        map(
            value => {
              return value;
            }
        ),
        catchError(this.handleError<any>(`Issue with end point ${endPoint}`))
    );

  }


  /**
   * Upload files to endpoint.
   * @param file
   * @param url
   * @protected
   */
  public upload(file: File, endPoint: string, dto?: any): Observable<HttpEvent<any>> {

    const formData: FormData = new FormData();

    formData.append("file", file);

    if (dto) {
      formData.append("dto", JSON.stringify(dto));
    }

    const req = new HttpRequest('POST', CoreApiService.baseUrl + endPoint, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }


  public create(dto: any, endPoint: string = "") : Observable<any>  {

    return this.http.post<any>(CoreApiService.baseUrl + endPoint, dto).pipe( tap(dtoDetail => {

          // convert DTO from OUT->IN

        }),
        catchError((error: HttpErrorResponse) => {
          this.handleError<any>("createError");

          throw error;

        })
    );

  }

  public post<T>(dto: any, endPoint: string = "") : Observable<T> {

    return this.http.post<any>(CoreApiService.baseUrl + endPoint, dto).pipe( tap(dtoDetail => {

        }),
        catchError(this.handleError<any>("Error"))
    );
  }


  /**
   * Delete Entity.
   * @param id
   */
  public delete(endPoint: string = ""): Observable<any> {

    // create URL
    const url = `${CoreApiService.baseUrl}${endPoint}`;;

    // delete entity
    return this.http.delete(url).pipe( tap(response => {

        }),
        catchError(this.handleError<any>("delete DTO"))
    );

  }

  public update(dto: any, endPoint: string = ""): Observable<any> {

    // create URL
    const url = `${CoreApiService.baseUrl}${endPoint}`

    return this.http.put<any>(url, dto).pipe( tap(dtoDetail => {

        }),
        catchError(this.handleError<any>("createError"))
    );
  }




  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  protected handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return throwError(error);
      //return of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    console.log(`CrudService: ${message}`);
  }

  public getDocumentBinary(endPoint:string):Observable<string> {

    return this.http.get<Blob>(CoreApiService.baseUrl + endPoint, { responseType : 'blob' as 'json'})
      .pipe(
        map(value => {
          let file = new Blob([value], { type: 'application/pdf' })
          return URL.createObjectURL(file);
        })
      );
  }


}
